import { App } from "antd";
import type { MessageInstance } from "antd/es/message/interface";

/**
 * Ant Design 5: Statik `message` dinamik `ConfigProvider` temasını kullanmaz.
 * `ThemeProvider` içindeki `<App message={...}>` altında kullanın.
 */
export function useAntdAppMessage(): MessageInstance {
  const { message } = App.useApp();
  return message;
}
